<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JZR6pf/tc-custom/9781429944892.jpg?1733102225045" alt="This image is the cover for the book Song to Die For"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Song to Die For
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A rousing tale mixing love, music, and mystery from Spur Award–winning author Mike Blakely.</b><br/><br/> It's 1975 and guitarist and singer/songwriter Creed Mason hopes to ride the new wave of Texas-style, Austin-based country music all the way back to the big time. A one-hit wonder whose Nashville career was cut short by a trip to Vietnam, Creed is desperate to get back into the business. His break arrives when a country legend, Luster Burnett, comes out of a fifteen-year retirement for one last album and tour in order to pay off a huge debt to the I.R.S. As Luster's new guitarist and band manager, Creed jumps at the chance of a lifetime.<br/><br/> Rosa Martini, a beautiful young mob princess from Las Vegas, is found dead just outside of Austin. Texas Ranger Captain Hooley Johnson looks into the case, only to find a second young woman murdered—a friend of Rosa's. To complicate things, Rosa's adoptive brother, mob hit man Franco Martini, is spotted nosing around Austin in the wake of the murders.<br/><br/> Soon it appears to Johnson, and to Creed, that the mob-related murders and the band are somehow connected. When the band wins an unexpected booking at the biggest casino in Vegas, Creed begins to wonder what kind of contract his band is being set up for—a major-label recording deal, or a mob hit?<br/>   </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mike Blakely
      </h2>
      
      <p class="authorDescription body article"><P>MIKE BLAKELY is the author of several novels of the West, including <I>Comanche Dawn</I> and <I>Moon Medicine</I>. His novel <I>Summer of Pearls</I> won the Spur Award for Best Novel in 2001. Blakely makes his home in Marble Falls, Texas.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ee4b10a6